import { gql } from "@apollo/client"

const GET_MIS_GUARDIAN_EMAILS_XLS_DOWNLOAD = gql`
  query($clientId: ID!) {
    misGuardianEmailsXlsDownload(client_id: $clientId) {
      filename
      url
      type
      queued
    }
  }
`

export { GET_MIS_GUARDIAN_EMAILS_XLS_DOWNLOAD }